import type { MerchantDetail, MerchantListItem, MerchantStatus } from "../types/merchant.types";

const merchantPartnerTypeTranslationKeys: Record<string, string> = {
  cities_municipalities: "merchant.partner_type_cities_municipalities",
  local_businesses: "merchant.partner_type_local_businesses",
  corporate: "merchant.partner_type_corporate",
  nonprofits_community_organizations: "merchant.partner_type_nonprofits_community_organizations",
};

export const getMerchantPartnerTypeTranslationKey = (partnerType: string | null) =>
  partnerType ? merchantPartnerTypeTranslationKeys[partnerType] : undefined;

export const getMerchantStatus = (
  merchant: Pick<
    MerchantListItem,
    "verification_status" | "requires_reverification" | "user_status"
  >,
): MerchantStatus => {
  const userStatus = merchant.user_status?.toLowerCase() ?? "";
  if (userStatus === "deactivated" || userStatus === "inactive" || userStatus === "suspended") {
    return "suspended";
  }
  if (merchant.requires_reverification) {
    return "suspended";
  }
  return merchant.verification_status ? "verified" : "pending";
};

export const isMerchantVerified = (
  merchant: Pick<MerchantListItem, "verification_status">,
): boolean => merchant.verification_status === true;

export const formatMerchantDate = (value: string | null | undefined): string => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  }).format(date);
};

export const getMerchantDisplayName = (
  merchant: Pick<MerchantListItem, "business_name" | "email">,
): string => merchant.business_name || merchant.email || "—";

export const mapMerchantToFormValues = (
  merchant: MerchantDetail,
): {
  business_name: string;
  short_intro: string;
  description: string;
  business_url: string;
  business_category_id: string;
  partner_type: string;
  phone: string;
} => ({
  business_name: merchant.business_name ?? "",
  short_intro: merchant.short_intro ?? "",
  description: merchant.description ?? "",
  business_url: merchant.business_url ?? "",
  business_category_id: merchant.category_id ?? "",
  partner_type: merchant.partner_type ?? "",
  phone: merchant.phone ?? "",
});
